//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './HL7MessageClient'
export { Client };
import type { AxiosRequestConfig } from 'axios';

export type GetMessagesHL7MessageQueryParameters = {
  id?: number | null | undefined ;
  from?: Date | null | undefined ;
  to?: Date | null | undefined ;
  direction?: Types.HL7MessageDirection | null | undefined ;
  type?: Types.HL7MessageType | null | undefined ;
  status?: Types.GDTMessageStatus | null | undefined ;
  search?: string | null | undefined ;
  searchByError?: string | null | undefined ;
  patientId?: number | null | undefined ;
  limitContentLength?: boolean | undefined ;
  removeContent?: boolean | undefined ;
  pagination_Offset?: number | undefined ;
  pagination_Limit?: number | undefined ;
  sorting_SortField?: string | null | undefined ;
  sorting_SortDirection?: Types.SortDirection | undefined ;
  additionalSorting?: Types.SortingDto[] | null | undefined ;
}

export type ReprocessMessageHL7MessageQueryParameters = {
  id?: number | null | undefined ;
  from?: Date | null | undefined ;
  to?: Date | null | undefined ;
  direction?: Types.HL7MessageDirection | null | undefined ;
  type?: Types.HL7MessageType | null | undefined ;
  status?: Types.GDTMessageStatus | null | undefined ;
  search?: string | null | undefined ;
  searchByError?: string | null | undefined ;
  patientId?: number | null | undefined ;
  limitContentLength?: boolean | undefined ;
  removeContent?: boolean | undefined ;
  pagination_Offset?: number | undefined ;
  pagination_Limit?: number | undefined ;
  sorting_SortField?: string | null | undefined ;
  sorting_SortDirection?: Types.SortDirection | undefined ;
  additionalSorting?: Types.SortingDto[] | null | undefined ;
  useFilters?: boolean | undefined ;
}

export type RemoveHL7MessageQueryParameters = {
  id: number ;
}

export function getMessagesUrl(id?: number | null | undefined, from?: Date | null | undefined, to?: Date | null | undefined, direction?: Types.HL7MessageDirection | null | undefined, type?: Types.HL7MessageType | null | undefined, status?: Types.GDTMessageStatus | null | undefined, search?: string | null | undefined, searchByError?: string | null | undefined, patientId?: number | null | undefined, limitContentLength?: boolean | undefined, removeContent?: boolean | undefined, pagination_Offset?: number | undefined, pagination_Limit?: number | undefined, sorting_SortField?: string | null | undefined, sorting_SortDirection?: Types.SortDirection | undefined, additionalSorting?: Types.SortingDto[] | null | undefined): string {
  let url_ = getBaseUrl() + "/api/hl7/messages?";
if (id !== undefined && id !== null)
    url_ += "Id=" + encodeURIComponent("" + id) + "&";
if (from !== undefined && from !== null)
    url_ += "From=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
if (to !== undefined && to !== null)
    url_ += "To=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
if (direction !== undefined && direction !== null)
    url_ += "Direction=" + encodeURIComponent("" + direction) + "&";
if (type !== undefined && type !== null)
    url_ += "Type=" + encodeURIComponent("" + type) + "&";
if (status !== undefined && status !== null)
    url_ += "Status=" + encodeURIComponent("" + status) + "&";
if (search !== undefined && search !== null)
    url_ += "Search=" + encodeURIComponent("" + search) + "&";
if (searchByError !== undefined && searchByError !== null)
    url_ += "SearchByError=" + encodeURIComponent("" + searchByError) + "&";
if (patientId !== undefined && patientId !== null)
    url_ += "PatientId=" + encodeURIComponent("" + patientId) + "&";
if (limitContentLength === null)
    throw new Error("The parameter 'limitContentLength' cannot be null.");
else if (limitContentLength !== undefined)
    url_ += "LimitContentLength=" + encodeURIComponent("" + limitContentLength) + "&";
if (removeContent === null)
    throw new Error("The parameter 'removeContent' cannot be null.");
else if (removeContent !== undefined)
    url_ += "RemoveContent=" + encodeURIComponent("" + removeContent) + "&";
if (pagination_Offset === null)
    throw new Error("The parameter 'pagination_Offset' cannot be null.");
else if (pagination_Offset !== undefined)
    url_ += "Pagination.Offset=" + encodeURIComponent("" + pagination_Offset) + "&";
if (pagination_Limit === null)
    throw new Error("The parameter 'pagination_Limit' cannot be null.");
else if (pagination_Limit !== undefined)
    url_ += "Pagination.Limit=" + encodeURIComponent("" + pagination_Limit) + "&";
if (sorting_SortField !== undefined && sorting_SortField !== null)
    url_ += "Sorting.SortField=" + encodeURIComponent("" + sorting_SortField) + "&";
if (sorting_SortDirection === null)
    throw new Error("The parameter 'sorting_SortDirection' cannot be null.");
else if (sorting_SortDirection !== undefined)
    url_ += "Sorting.SortDirection=" + encodeURIComponent("" + sorting_SortDirection) + "&";
if (additionalSorting !== undefined && additionalSorting !== null)
    additionalSorting && additionalSorting.forEach((item, index) => {
        for (let attr in item)
			if (item.hasOwnProperty(attr)) {
				url_ += "AdditionalSorting[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
			}
    });
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getMessagesDefaultOptions: Omit<UseQueryOptions<Types.PageableListDtoOfHL7MessageDto, unknown, Types.PageableListDtoOfHL7MessageDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.PageableListDtoOfHL7MessageDto, unknown, Types.PageableListDtoOfHL7MessageDto>, 'queryFn'>> = {
};
export function getGetMessagesDefaultOptions() {
  return getMessagesDefaultOptions;
};
export function setGetMessagesDefaultOptions(options: typeof getMessagesDefaultOptions) {
  getMessagesDefaultOptions = options;
}

export function getMessagesQueryKey(dto: GetMessagesHL7MessageQueryParameters): QueryKey;
export function getMessagesQueryKey(id?: number | null | undefined, from?: Date | null | undefined, to?: Date | null | undefined, direction?: Types.HL7MessageDirection | null | undefined, type?: Types.HL7MessageType | null | undefined, status?: Types.GDTMessageStatus | null | undefined, search?: string | null | undefined, searchByError?: string | null | undefined, patientId?: number | null | undefined, limitContentLength?: boolean | undefined, removeContent?: boolean | undefined, pagination_Offset?: number | undefined, pagination_Limit?: number | undefined, sorting_SortField?: string | null | undefined, sorting_SortDirection?: Types.SortDirection | undefined, additionalSorting?: Types.SortingDto[] | null | undefined): QueryKey;
export function getMessagesQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { id, from, to, direction, type, status, search, searchByError, patientId, limitContentLength, removeContent, pagination_Offset, pagination_Limit, sorting_SortField, sorting_SortDirection, additionalSorting,  } = params[0] as GetMessagesHL7MessageQueryParameters;

    return trimArrayEnd([
        'HL7MessageClient',
        'getMessages',
        id as any,
        from as any,
        to as any,
        direction as any,
        type as any,
        status as any,
        search as any,
        searchByError as any,
        patientId as any,
        limitContentLength as any,
        removeContent as any,
        pagination_Offset as any,
        pagination_Limit as any,
        sorting_SortField as any,
        sorting_SortDirection as any,
        additionalSorting as any,
      ]);
  } else {
    return trimArrayEnd([
        'HL7MessageClient',
        'getMessages',
        ...params
      ]);
  }
}
export function __getMessages(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.getMessages(
      context.queryKey[2] as number | null | undefined,       context.queryKey[3] as Date | null | undefined,       context.queryKey[4] as Date | null | undefined,       context.queryKey[5] as Types.HL7MessageDirection | null | undefined,       context.queryKey[6] as Types.HL7MessageType | null | undefined,       context.queryKey[7] as Types.GDTMessageStatus | null | undefined,       context.queryKey[8] as string | null | undefined,       context.queryKey[9] as string | null | undefined,       context.queryKey[10] as number | null | undefined,       context.queryKey[11] as boolean | undefined,       context.queryKey[12] as boolean | undefined,       context.queryKey[13] as number | undefined,       context.queryKey[14] as number | undefined,       context.queryKey[15] as string | null | undefined,       context.queryKey[16] as Types.SortDirection | undefined,       context.queryKey[17] as Types.SortingDto[] | null | undefined,axiosConfig    );
}

export function useGetMessagesQuery<TSelectData = Types.PageableListDtoOfHL7MessageDto, TError = unknown>(dto: GetMessagesHL7MessageQueryParameters, options?: Omit<UseQueryOptions<Types.PageableListDtoOfHL7MessageDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Gets HL7 messages.
 * @param id (optional) 
 * @param from (optional) 
 * @param to (optional) 
 * @param direction (optional) 
 * @param type (optional) 
 * @param status (optional) 
 * @param search (optional) 
 * @param searchByError (optional) 
 * @param patientId (optional) 
 * @param limitContentLength (optional) Content of HL7 could be quite big (e.g. if it embeds the base64 file).
So for showing it to a user in UI it'd be good to limit the length
 * @param removeContent (optional) Do not return Content at all
(could be used in Patient pages where we show the status depending on the presence of the message, ignoring the content)
 * @param pagination_Offset (optional) 
 * @param pagination_Limit (optional) 
 * @param sorting_SortField (optional) 
 * @param sorting_SortDirection (optional) 
 * @param additionalSorting (optional) 
 */
export function useGetMessagesQuery<TSelectData = Types.PageableListDtoOfHL7MessageDto, TError = unknown>(id?: number | null | undefined, from?: Date | null | undefined, to?: Date | null | undefined, direction?: Types.HL7MessageDirection | null | undefined, type?: Types.HL7MessageType | null | undefined, status?: Types.GDTMessageStatus | null | undefined, search?: string | null | undefined, searchByError?: string | null | undefined, patientId?: number | null | undefined, limitContentLength?: boolean | undefined, removeContent?: boolean | undefined, pagination_Offset?: number | undefined, pagination_Limit?: number | undefined, sorting_SortField?: string | null | undefined, sorting_SortDirection?: Types.SortDirection | undefined, additionalSorting?: Types.SortingDto[] | null | undefined, options?: Omit<UseQueryOptions<Types.PageableListDtoOfHL7MessageDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetMessagesQuery<TSelectData = Types.PageableListDtoOfHL7MessageDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.PageableListDtoOfHL7MessageDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let id: any = undefined;
  let from: any = undefined;
  let to: any = undefined;
  let direction: any = undefined;
  let type: any = undefined;
  let status: any = undefined;
  let search: any = undefined;
  let searchByError: any = undefined;
  let patientId: any = undefined;
  let limitContentLength: any = undefined;
  let removeContent: any = undefined;
  let pagination_Offset: any = undefined;
  let pagination_Limit: any = undefined;
  let sorting_SortField: any = undefined;
  let sorting_SortDirection: any = undefined;
  let additionalSorting: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ id, from, to, direction, type, status, search, searchByError, patientId, limitContentLength, removeContent, pagination_Offset, pagination_Limit, sorting_SortField, sorting_SortDirection, additionalSorting,  } = params[0] as GetMessagesHL7MessageQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [id, from, to, direction, type, status, search, searchByError, patientId, limitContentLength, removeContent, pagination_Offset, pagination_Limit, sorting_SortField, sorting_SortDirection, additionalSorting, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.PageableListDtoOfHL7MessageDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __getMessages(context, axiosConfig) : __getMessages,
    queryKey: getMessagesQueryKey(id, from, to, direction, type, status, search, searchByError, patientId, limitContentLength, removeContent, pagination_Offset, pagination_Limit, sorting_SortField, sorting_SortDirection, additionalSorting),
    ...getMessagesDefaultOptions as unknown as Omit<UseQueryOptions<Types.PageableListDtoOfHL7MessageDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * Gets HL7 messages.
 * @param id (optional) 
 * @param from (optional) 
 * @param to (optional) 
 * @param direction (optional) 
 * @param type (optional) 
 * @param status (optional) 
 * @param search (optional) 
 * @param searchByError (optional) 
 * @param patientId (optional) 
 * @param limitContentLength (optional) Content of HL7 could be quite big (e.g. if it embeds the base64 file).
So for showing it to a user in UI it'd be good to limit the length
 * @param removeContent (optional) Do not return Content at all
(could be used in Patient pages where we show the status depending on the presence of the message, ignoring the content)
 * @param pagination_Offset (optional) 
 * @param pagination_Limit (optional) 
 * @param sorting_SortField (optional) 
 * @param sorting_SortDirection (optional) 
 * @param additionalSorting (optional) 
 */
export function setGetMessagesData(queryClient: QueryClient, updater: (data: Types.PageableListDtoOfHL7MessageDto | undefined) => Types.PageableListDtoOfHL7MessageDto, id?: number | null | undefined, from?: Date | null | undefined, to?: Date | null | undefined, direction?: Types.HL7MessageDirection | null | undefined, type?: Types.HL7MessageType | null | undefined, status?: Types.GDTMessageStatus | null | undefined, search?: string | null | undefined, searchByError?: string | null | undefined, patientId?: number | null | undefined, limitContentLength?: boolean | undefined, removeContent?: boolean | undefined, pagination_Offset?: number | undefined, pagination_Limit?: number | undefined, sorting_SortField?: string | null | undefined, sorting_SortDirection?: Types.SortDirection | undefined, additionalSorting?: Types.SortingDto[] | null | undefined) {
  queryClient.setQueryData(getMessagesQueryKey(id, from, to, direction, type, status, search, searchByError, patientId, limitContentLength, removeContent, pagination_Offset, pagination_Limit, sorting_SortField, sorting_SortDirection, additionalSorting),
    updater
  );
}

/**
 * Gets HL7 messages.
 * @param id (optional) 
 * @param from (optional) 
 * @param to (optional) 
 * @param direction (optional) 
 * @param type (optional) 
 * @param status (optional) 
 * @param search (optional) 
 * @param searchByError (optional) 
 * @param patientId (optional) 
 * @param limitContentLength (optional) Content of HL7 could be quite big (e.g. if it embeds the base64 file).
So for showing it to a user in UI it'd be good to limit the length
 * @param removeContent (optional) Do not return Content at all
(could be used in Patient pages where we show the status depending on the presence of the message, ignoring the content)
 * @param pagination_Offset (optional) 
 * @param pagination_Limit (optional) 
 * @param sorting_SortField (optional) 
 * @param sorting_SortDirection (optional) 
 * @param additionalSorting (optional) 
 */
export function setGetMessagesDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.PageableListDtoOfHL7MessageDto | undefined) => Types.PageableListDtoOfHL7MessageDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function reprocessMessageUrl(id?: number | null | undefined, from?: Date | null | undefined, to?: Date | null | undefined, direction?: Types.HL7MessageDirection | null | undefined, type?: Types.HL7MessageType | null | undefined, status?: Types.GDTMessageStatus | null | undefined, search?: string | null | undefined, searchByError?: string | null | undefined, patientId?: number | null | undefined, limitContentLength?: boolean | undefined, removeContent?: boolean | undefined, pagination_Offset?: number | undefined, pagination_Limit?: number | undefined, sorting_SortField?: string | null | undefined, sorting_SortDirection?: Types.SortDirection | undefined, additionalSorting?: Types.SortingDto[] | null | undefined, useFilters?: boolean | undefined): string {
  let url_ = getBaseUrl() + "/api/hl7/messages/process?";
if (id !== undefined && id !== null)
    url_ += "Id=" + encodeURIComponent("" + id) + "&";
if (from !== undefined && from !== null)
    url_ += "From=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
if (to !== undefined && to !== null)
    url_ += "To=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
if (direction !== undefined && direction !== null)
    url_ += "Direction=" + encodeURIComponent("" + direction) + "&";
if (type !== undefined && type !== null)
    url_ += "Type=" + encodeURIComponent("" + type) + "&";
if (status !== undefined && status !== null)
    url_ += "Status=" + encodeURIComponent("" + status) + "&";
if (search !== undefined && search !== null)
    url_ += "Search=" + encodeURIComponent("" + search) + "&";
if (searchByError !== undefined && searchByError !== null)
    url_ += "SearchByError=" + encodeURIComponent("" + searchByError) + "&";
if (patientId !== undefined && patientId !== null)
    url_ += "PatientId=" + encodeURIComponent("" + patientId) + "&";
if (limitContentLength === null)
    throw new Error("The parameter 'limitContentLength' cannot be null.");
else if (limitContentLength !== undefined)
    url_ += "LimitContentLength=" + encodeURIComponent("" + limitContentLength) + "&";
if (removeContent === null)
    throw new Error("The parameter 'removeContent' cannot be null.");
else if (removeContent !== undefined)
    url_ += "RemoveContent=" + encodeURIComponent("" + removeContent) + "&";
if (pagination_Offset === null)
    throw new Error("The parameter 'pagination_Offset' cannot be null.");
else if (pagination_Offset !== undefined)
    url_ += "Pagination.Offset=" + encodeURIComponent("" + pagination_Offset) + "&";
if (pagination_Limit === null)
    throw new Error("The parameter 'pagination_Limit' cannot be null.");
else if (pagination_Limit !== undefined)
    url_ += "Pagination.Limit=" + encodeURIComponent("" + pagination_Limit) + "&";
if (sorting_SortField !== undefined && sorting_SortField !== null)
    url_ += "Sorting.SortField=" + encodeURIComponent("" + sorting_SortField) + "&";
if (sorting_SortDirection === null)
    throw new Error("The parameter 'sorting_SortDirection' cannot be null.");
else if (sorting_SortDirection !== undefined)
    url_ += "Sorting.SortDirection=" + encodeURIComponent("" + sorting_SortDirection) + "&";
if (additionalSorting !== undefined && additionalSorting !== null)
    additionalSorting && additionalSorting.forEach((item, index) => {
        for (let attr in item)
			if (item.hasOwnProperty(attr)) {
				url_ += "AdditionalSorting[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
			}
    });
if (useFilters === null)
    throw new Error("The parameter 'useFilters' cannot be null.");
else if (useFilters !== undefined)
    url_ += "useFilters=" + encodeURIComponent("" + useFilters) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function reprocessMessageMutationKey(id?: number | null | undefined, from?: Date | null | undefined, to?: Date | null | undefined, direction?: Types.HL7MessageDirection | null | undefined, type?: Types.HL7MessageType | null | undefined, status?: Types.GDTMessageStatus | null | undefined, search?: string | null | undefined, searchByError?: string | null | undefined, patientId?: number | null | undefined, limitContentLength?: boolean | undefined, removeContent?: boolean | undefined, pagination_Offset?: number | undefined, pagination_Limit?: number | undefined, sorting_SortField?: string | null | undefined, sorting_SortDirection?: Types.SortDirection | undefined, additionalSorting?: Types.SortingDto[] | null | undefined, useFilters?: boolean | undefined): MutationKey {
  return trimArrayEnd([
      'HL7MessageClient',
      'reprocessMessage',
      id as any,
      from as any,
      to as any,
      direction as any,
      type as any,
      status as any,
      search as any,
      searchByError as any,
      patientId as any,
      limitContentLength as any,
      removeContent as any,
      pagination_Offset as any,
      pagination_Limit as any,
      sorting_SortField as any,
      sorting_SortDirection as any,
      additionalSorting as any,
      useFilters as any,
    ]);
}

/**
 * Starts re-processing of messages that fit the filter.
 * @param id (optional) 
 * @param from (optional) 
 * @param to (optional) 
 * @param direction (optional) 
 * @param type (optional) 
 * @param status (optional) 
 * @param search (optional) 
 * @param searchByError (optional) 
 * @param patientId (optional) 
 * @param limitContentLength (optional) Content of HL7 could be quite big (e.g. if it embeds the base64 file).
So for showing it to a user in UI it'd be good to limit the length
 * @param removeContent (optional) Do not return Content at all
(could be used in Patient pages where we show the status depending on the presence of the message, ignoring the content)
 * @param pagination_Offset (optional) 
 * @param pagination_Limit (optional) 
 * @param sorting_SortField (optional) 
 * @param sorting_SortDirection (optional) 
 * @param additionalSorting (optional) 
 * @param useFilters (optional) 
 */
export function useReprocessMessageMutation<TContext>(id?: number | null | undefined, from?: Date | null | undefined, to?: Date | null | undefined, direction?: Types.HL7MessageDirection | null | undefined, type?: Types.HL7MessageType | null | undefined, status?: Types.GDTMessageStatus | null | undefined, search?: string | null | undefined, searchByError?: string | null | undefined, patientId?: number | null | undefined, limitContentLength?: boolean | undefined, removeContent?: boolean | undefined, pagination_Offset?: number | undefined, pagination_Limit?: number | undefined, sorting_SortField?: string | null | undefined, sorting_SortDirection?: Types.SortDirection | undefined, additionalSorting?: Types.SortingDto[] | null | undefined, useFilters?: boolean | undefined, options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = reprocessMessageMutationKey(id, from, to, direction, type, status, search, searchByError, patientId, limitContentLength, removeContent, pagination_Offset, pagination_Limit, sorting_SortField, sorting_SortDirection, additionalSorting, useFilters);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.reprocessMessage(id, from, to, direction, type, status, search, searchByError, patientId, limitContentLength, removeContent, pagination_Offset, pagination_Limit, sorting_SortField, sorting_SortDirection, additionalSorting, useFilters),
    mutationKey: key,
  });
}
  
type ReprocessMessage__MutationParameters = ReprocessMessageHL7MessageQueryParameters

/**
 * Starts re-processing of messages that fit the filter.
 * @param id (optional) 
 * @param from (optional) 
 * @param to (optional) 
 * @param direction (optional) 
 * @param type (optional) 
 * @param status (optional) 
 * @param search (optional) 
 * @param searchByError (optional) 
 * @param patientId (optional) 
 * @param limitContentLength (optional) Content of HL7 could be quite big (e.g. if it embeds the base64 file).
So for showing it to a user in UI it'd be good to limit the length
 * @param removeContent (optional) Do not return Content at all
(could be used in Patient pages where we show the status depending on the presence of the message, ignoring the content)
 * @param pagination_Offset (optional) 
 * @param pagination_Limit (optional) 
 * @param sorting_SortField (optional) 
 * @param sorting_SortDirection (optional) 
 * @param additionalSorting (optional) 
 * @param useFilters (optional) 
 */
export function useReprocessMessageMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, ReprocessMessage__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: ReprocessMessageHL7MessageQueryParameters}): UseMutationResult<void, unknown, ReprocessMessage__MutationParameters, TContext> {
  const key = reprocessMessageMutationKey(options?.parameters?.id!, options?.parameters?.from!, options?.parameters?.to!, options?.parameters?.direction!, options?.parameters?.type!, options?.parameters?.status!, options?.parameters?.search!, options?.parameters?.searchByError!, options?.parameters?.patientId!, options?.parameters?.limitContentLength!, options?.parameters?.removeContent!, options?.parameters?.pagination_Offset!, options?.parameters?.pagination_Limit!, options?.parameters?.sorting_SortField!, options?.parameters?.sorting_SortDirection!, options?.parameters?.additionalSorting!, options?.parameters?.useFilters!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: ReprocessMessage__MutationParameters) => Client.reprocessMessage(data.id ?? options?.parameters?.id!, data.from ?? options?.parameters?.from!, data.to ?? options?.parameters?.to!, data.direction ?? options?.parameters?.direction!, data.type ?? options?.parameters?.type!, data.status ?? options?.parameters?.status!, data.search ?? options?.parameters?.search!, data.searchByError ?? options?.parameters?.searchByError!, data.patientId ?? options?.parameters?.patientId!, data.limitContentLength ?? options?.parameters?.limitContentLength!, data.removeContent ?? options?.parameters?.removeContent!, data.pagination_Offset ?? options?.parameters?.pagination_Offset!, data.pagination_Limit ?? options?.parameters?.pagination_Limit!, data.sorting_SortField ?? options?.parameters?.sorting_SortField!, data.sorting_SortDirection ?? options?.parameters?.sorting_SortDirection!, data.additionalSorting ?? options?.parameters?.additionalSorting!, data.useFilters ?? options?.parameters?.useFilters!),
  mutationKey: key,
});
}
  
export function removeUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/hl7/messages/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function removeMutationKey(id: number): MutationKey {
  return trimArrayEnd([
      'HL7MessageClient',
      'remove',
      id as any,
    ]);
}

/**
 * Removes GDT message.
 * @param id The message id.
 */
export function useRemoveMutation<TContext>(id: number, options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = removeMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.remove(id),
    mutationKey: key,
  });
}
  
type Remove__MutationParameters = RemoveHL7MessageQueryParameters

/**
 * Removes GDT message.
 * @param id The message id.
 */
export function useRemoveMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, Remove__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: RemoveHL7MessageQueryParameters}): UseMutationResult<void, unknown, Remove__MutationParameters, TContext> {
  const key = removeMutationKey(options?.parameters?.id!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: Remove__MutationParameters) => Client.remove(data.id ?? options?.parameters?.id!),
  mutationKey: key,
});
}